import tw, { styled } from "twin.macro"

const Label = styled.label`
  ${tw`block text-sm font-medium leading-5 text-gray-700`}
`

export default Label
